<template>
  <v-footer class="footerbox pa-0"
            absolute>

    <v-container class="footer-content pa-0" fluid>
      <v-row class="mx-12 flex-nowrap" no-gutters align-content="center">

        <a :href="impressumUrl"
           target="_blank"
           class="black87 mx-6">Impressum
        </a>
        <a :href="datenschutzUrl"
           target="_blank"
           class="black87 mx-6">Datenschutz
        </a>
        <a :href="verbraucherschutzUrl"
           target="_blank"
           class="black87 mx-6">Verbraucherschutz
        </a>

        <v-spacer />

        <div class="copyright mx-4">
          ©&nbsp;DMB&nbsp;Rechtsschutz&nbsp;{{ (new Date()).getFullYear() }}
        </div>


      </v-row>
    </v-container>

  </v-footer>
</template>

<script>
import {datenschutzUrl, verbraucherschutzUrl, impressumUrl} from "@/store/config/externalLinks";

export default {
  data: function () {
    return {
      datenschutzUrl,
      verbraucherschutzUrl,
      impressumUrl
    };
  }
};
</script>

<style>
.footerbox {
  min-height: 48px;
  height: auto;
}

.footerbox .footer-content {
  max-width: 1280px;
  width: 100%;
  margin: auto;
}

.footerbox .copyright {
  color: rgba(0, 0, 0, .38);
  font-size: 9pt;
}

.footerbox a:hover {
  color: #0085CF !important;
}

</style>

